/**
 * chatelles-size-notify.js — Chatelles
 *
 * Sur la fiche produit, quand le client clique une taille ÉPUISÉE dans le
 * variant-picker :
 *   1. on ouvre directement le popup « Prévenez-moi » (app Back in Stock,
 *      GrootApps — bouton #notifyMeButton / modale #notifyMeModal) ;
 *   2. on force le menu déroulant du popup (#notifyVariantSelect) sur la taille
 *      cliquée — l'app pré-sélectionne sinon toujours la première taille
 *      épuisée, pas celle voulue.
 *
 * Déclenchement 100 % au CLIC : la taille et sa disponibilité sont déjà
 * connues sur l'option cliquée (valeur de la radio + data-option-available), on
 * n'attend donc aucun event asynchrone → pas de décalage même en enchaînant
 * plusieurs tailles rapidement. Quand la modale est déjà ouverte, le forçage
 * est synchrone (instantané).
 *
 * Le bouton « Prévenez-moi » natif de l'app reste inchangé.
 */
(function () {
  'use strict';

  // Jeton de génération : chaque nouvelle sélection invalide la boucle de
  // forçage précédente (évite que plusieurs boucles se disputent le <select>).
  var token = 0;

  // Le <select> du popup mappe texte(=taille) → value(=id variante). On cible
  // par le TEXTE car c'est ce qu'on connaît au clic (valeur de la radio).
  function forceSizeByText(sizeText) {
    var sel = document.getElementById('notifyVariantSelect');
    if (!sel || !sizeText) return;
    var target = Array.prototype.filter.call(sel.options, function (o) {
      return o.textContent.trim() === sizeText;
    })[0];
    if (!target) return;
    if (sel.value !== target.value) {
      sel.value = target.value;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function openNotifyForSize(sizeText) {
    var myToken = ++token; // invalide toute boucle antérieure
    var btn = document.getElementById('notifyMeButton');
    if (!btn) return; // app non chargée

    var modal = document.getElementById('notifyMeModal');
    var alreadyOpen = modal && getComputedStyle(modal).display !== 'none';
    if (!alreadyOpen) btn.click();

    // 1er passage synchrone (instantané si la modale est déjà ouverte), puis on
    // ré-applique tant que c'est la sélection courante : le popup se rend de
    // façon asynchrone à la 1re ouverture et l'app peut réinitialiser le <select>.
    var tries = 0;
    (function loop() {
      if (myToken !== token) return; // une sélection plus récente a pris le relais
      var m = document.getElementById('notifyMeModal');
      if (m && getComputedStyle(m).display !== 'none') forceSizeByText(sizeText);
      if (tries++ < 18) setTimeout(loop, 100);
    })();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('variant-picker')) return;

    var label = e.target.closest('.variant-option__button-label');
    var radio = label
      ? label.querySelector('input[type="radio"]')
      : (e.target.matches && e.target.matches('input[type="radio"]') ? e.target : null);
    if (!radio) return;

    var sizeText = (radio.value || '').trim();
    var unavailable = radio.dataset.optionAvailable === 'false' ||
                      radio.getAttribute('aria-disabled') === 'true';

    if (unavailable && sizeText) {
      openNotifyForSize(sizeText);
    } else {
      token++; // taille disponible → on stoppe tout forçage en cours
    }
  }, false);

})();
